import cn from 'classnames';
import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { MyAddresses } from '@desquared/wave-components-library';
import { DeleteAddressModal } from '@desquared/wave-components-library';
import { useTranslations } from 'next-intl';

import NoAddressesFound from '../../../public/assets/wave-grocery/Empty-States-Default/Credit-Cards.png';
import { ResponsiveMenuStore } from '@/store/sideSheet';
import CUSTOM_STYLES from '@/utils/modalStyle';
import { getCardList } from '@/utils/cards';
import { deleteCreditCard } from '@/api/users';

import styles from '@/styles/User.module.css';

export default function CardsSection({ user, image }) {
  const { token } = user;
  const [toDelete, setToDelete] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const openMenu = () => {
    ResponsiveMenuStore.open();
  };

  const t = useTranslations();

  async function onClickDeleteCC(authorization, card) {
    const res = await deleteCreditCard(authorization, card);
    if (typeof res === 'string') {
      setShowDeleteModal(false);
      // setErrorModal(true);
      return;
    }
    setToDelete({});
    setShowDeleteModal(false);
  }

  const onDeleteClick = id => {
    setToDelete(id);
    setShowDeleteModal(true);
  };

  return (
    <>
      {showDeleteModal && (
        <ReactModal
          isOpen={showDeleteModal}
          onRequestClose={() => {
            setShowDeleteModal(false);
          }}
          style={CUSTOM_STYLES}
          contentLabel={'delete modal'}
          ariaHideApp={false}
          className={cn(styles.modalContainer, styles.modal)}
          shouldCloseOnOverlayClick={true}
        >
          <DeleteAddressModal
            title={t('user_cards.delete_modal.title')}
            description={t('user_cards.delete_modal.description')}
            cancelWording={t('user_cards.delete_modal.cancel')}
            onDelete={() => {
              onClickDeleteCC(token, toDelete);
            }}
            onCancel={() => {
              setShowDeleteModal(false);
              setToDelete({});
            }}
            deleteWording={t('user_cards.delete_modal.delete')}
          />
        </ReactModal>
      )}

      <MyAddresses
        title={t('user_cards.title')}
        noItemsFoundWording={t('user_cards.no_items')}
        noItemsFoundImage={image ? image : NoAddressesFound.src}
        onBack={() => {
          openMenu();
        }}
        ItemList={user?.creditCards?.length > 0 ? getCardList(user.creditCards, onDeleteClick) : undefined}
      />
    </>
  );
}
